@if (mapLoader) {
  <div class="relative h-full rounded-3 border border-grey-300 lg:flex lg:space-x-md lg:rounded-none lg:border-none">
    <div class="rounded-t-3 lg:w-1/2 lg:rounded-3 xl:w-3/5 2xl:w-2/3">
      @for (location of mapLoader.preloadedLocations; track location) {
        <cft-map-address
          [address]="location.location.address"
          [gMapsApiKey]="googleMapsApiKey"
          [showMap]="location.showMap"
          [ngClass]="{'h-96 w-full': location.showMap, hidden: !location.showMap}"
        ></cft-map-address>
      }
    </div>
    @if (mapLoader.current.location; as location) {
      <div class="p-xl lg:w-1/2 xl:w-2/5 2xl:w-1/3">
        <div class="flex justify-between">
          <div
            [class.cursor-pointer]="mapLoader.hasPrevious"
            [class.text-grey-300]="!mapLoader.hasPrevious"
            (click)="mapLoader.previous()"
          >
            <fa-icon [icon]="leftIcon"></fa-icon>
          </div>
          <div class="heading-md">
            {{ location.default ? labels.defaultLocation : labels.location }} {{ location.address.locality }}
          </div>
          <div
            [class.cursor-pointer]="mapLoader.hasNext"
            [class.text-grey-300]="!mapLoader.hasNext"
            (click)="mapLoader.next()"
          >
            <fa-icon [icon]="rightIcon"></fa-icon>
          </div>
        </div>
        <div class="mt-xl flex justify-center text-base lg:text-md">
          <div class="space-y-md lg:pr-4xl">
            @if (location.googlePlace && location.googlePlace.rating) {
              <div class="mb-lg!">
                <cft-google-rating
                  [rating]="location.googlePlace.rating"
                  [numReviews]="location.googlePlace.userRatingCount"
                ></cft-google-rating>
              </div>
            }
            <div class="flex space-x-md">
              <div
                [style.width.px]="50"
                [style.height.px]="50"
                class="flex shrink-0 items-center justify-center rounded-full shadow-3"
              >
                <fa-icon [icon]="pinIcon"></fa-icon>
              </div>
              <div class="flex flex-col justify-center">
                @if (location.address.streetAndHouseNumber) {
                  <div>{{ location.address.streetAndHouseNumber }}</div>
                }
                <div>{{ location.address.postalCode }} {{ location.address.locality }}</div>
              </div>
            </div>
            @if (location.representativePerson; as representative) {
              <div class="flex space-x-md">
                <div
                  [style.width.px]="50"
                  [style.height.px]="50"
                  class="flex shrink-0 items-center justify-center rounded-full shadow-3"
                >
                  {{ representative | bgoInitials }}
                </div>
                <div class="flex flex-col justify-center">
                  <div>{{ representative | bgoFullName }}</div>
                  @if (representative.role) {
                    <div class="text-base text-president-200">{{ representative.role }}</div>
                  }
                </div>
              </div>
            }
            @if (mapLoader.current.associations.length) {
              <div class="flex space-x-md">
                <div
                  [style.width.px]="50"
                  [style.height.px]="50"
                  class="flex shrink-0 items-center justify-center rounded-full shadow-3"
                >
                  <fa-icon [icon]="associationsIcon"></fa-icon>
                </div>
                <div class="flex flex-col justify-center">
                  <div>{{ labels.associations }}</div>
                  @for (a of mapLoader.current.associations; track a) {
                    <div class="text-sm break-all text-president-200 lg:text-base">
                      {{ a }}
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
}
